import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

import { AutoFocusHeader } from '../../../_components/auto-focus-header';
import { StartOverButton } from '../../../_components/start-over-button';

import styles from './styles.module.scss';
export function RequestSent({
  email,
  onNext,
}: {
  email: string;
  onNext: () => void;
}) {
  const message = `You have been sent an email to ${email} with a secured link to the Precertification Portal.`;

  return (
    <div className="d-flex justify-content-center my-5">
      <Card className={`${styles.card} shadow-sm`}>
        <CardBody>
          <div className="text-center">
            <AutoFocusHeader>Email Sent</AutoFocusHeader>
            <p className="text-large mt-5">{message}</p>
            <p className="my-5">
              <FontAwesomeIcon
                icon={faCheckCircle}
                size="8x"
                className="d-inline-block text-green"
              />
            </p>
            <div className="mb-2">
              <StartOverButton onClick={() => onNext()} />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
